import React from 'react';

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
} from '@material-ui/core';
import PropTypes from 'prop-types';

import { t, number } from '~/helpers';

import * as S from './styles';

export default function ListData({ data }) {
  return (
    <S.WrapperContainer component={Paper}>
      <Table
        stickyHeader
        aria-label="sticky table"
        size="small"
        style={{ height: '100%' }}
      >
        <TableHead>
          <TableCell align="left">
            <S.TextField>Contingencia</S.TextField>
          </TableCell>
          <TableCell align="right">
            <S.TextField>{t('s.operacao.turno.abastecimentos')}</S.TextField>
          </TableCell>
          <TableCell align="right">
            <S.TextField>{t('s.relatorio.afericao.volume')}</S.TextField>
          </TableCell>
        </TableHead>
        <TableBody style={{ verticalAlign: 'bottom' }}>
          {data?.map((value, index) => (
            <TableRow>
              <TableCell align="left">
                {value.contingenciamovimentacaoabastecimentostr}
              </TableCell>
              <TableCell align="right">{number(value.registros, 0)}</TableCell>
              <TableCell align="right">{number(value.volumes, 0)}</TableCell>
            </TableRow>
          ))}
          <TableRow style={{ verticalAlign: 'bottom' }}>
            <TableCell align="left">
              <S.TextField>{t('Total')}</S.TextField>
            </TableCell>
            <TableCell align="right">
              <S.TextField>
                {number(
                  data?.reduce((a, b) => a + b.registros, 0),
                  0
                )}
              </S.TextField>
            </TableCell>
            <TableCell align="right">
              <S.TextField>
                {number(
                  data?.reduce((a, b) => a + b.volumes, 0),
                  0
                )}
              </S.TextField>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </S.WrapperContainer>
  );
}

ListData.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
};
